import * as React from 'react';
import type { SVGProps } from 'react';
const SvgForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M11.47 13.47a.75.75 0 1 0 1.06 1.06zM16 10l.53.53.53-.53-.53-.53zm-3.47-4.53a.75.75 0 1 0-1.06 1.06zM4 9.25a.75.75 0 0 0 0 1.5zm8.53 5.28 4-4-1.06-1.06-4 4zm4-5.06-4-4-1.06 1.06 4 4zM16 9.25H4v1.5h12z" />
  </svg>
);
export default SvgForward;
